import React from 'react';
import { getFrontendURL } from 'utils/app';

export default class AppRender extends React.PureComponent {
  render() {
    const { params, app, installedApp } = this.props;

    const frontendUrl = getFrontendURL(installedApp);

    return (
      <div className="app-container">
        <iframe src={`${frontendUrl}${params.splat}`} />
      </div>
    );
  }
}
